import React from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import { LoadingIcon } from '../Icon/SemanticIcons.esm.js';

function SheetBody({ addClassName, dataMetrics, dataTestId, isLoading = false, children, ...passThrough }) {
    if (isLoading) {
        return (React.createElement("div", { className: "tw-flex tw-items-center tw-justify-center tw-h-full" },
            React.createElement(LoadingIcon, { size: "3xl" })));
    }
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || "sheet-body", className: classNames("tw-p-4", addClassName), ...passThrough }, children));
}

export { SheetBody };
//# sourceMappingURL=SheetBody.esm.js.map
